module.exports = __webpack_public_path__ + "static/media/HP-LoginImage-Mobile-@1x.e78063eb.png";